// PWA: yükleme istemi (Chromium + iOS ipucu) ve yeni sürüm kontrolü
import { useEffect, useState } from 'react';
import { toast } from 'sonner';

let deferred = null;
const listeners = new Set();
const notify = () => listeners.forEach(fn => fn());
window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); deferred = e; notify(); });
window.addEventListener('appinstalled', () => { deferred = null; notify(); });

const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const useInstallPrompt = () => {
  const [, setTick] = useState(0);
  useEffect(() => {
    const fn = () => setTick(t => t + 1);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  const standalone = isStandalone();
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => null);
    deferred = null;
    notify();
  };
  return { canPrompt: !standalone && !!deferred, iosHint: !standalone && !deferred && isIos(), install };
};

const MAIN_JS = /\/static\/js\/main\.[\w]+\.js/;
const currentMain = () => [...document.scripts].map(s => s.src.match(MAIN_JS)?.[0]).find(Boolean);

// Sunucudaki index.html farklı bir ana paket gösteriyorsa yeni sürüm yayınlanmıştır
export const useUpdateCheck = () => {
  useEffect(() => {
    const mine = currentMain();
    if (!mine) return; // geliştirme ortamı
    let shown = false;
    const check = async () => {
      if (shown || document.hidden || !navigator.onLine) return;
      try {
        const html = await (await fetch('/', { cache: 'no-store' })).text();
        const latest = html.match(MAIN_JS)?.[0];
        if (latest && latest !== mine) {
          shown = true;
          toast('Yeni sürüm hazır', { description: 'Güncel sürümü kullanmak için sayfayı yenileyin.', duration: Infinity, action: { label: 'Yenile', onClick: () => window.location.reload() } });
        }
      } catch { /* çevrimdışı */ }
    };
    const t = setInterval(check, 5 * 60 * 1000);
    document.addEventListener('visibilitychange', check);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', check); };
  }, []);
};
